<template>
  <div>
    <a-row class="table-search">
      <table-search
        :fileds="ProjectSearch"
        :form="queryForm"
        @search="searchList"
        @reset="handleReset">
      </table-search>
    </a-row>
    <div class="tablebox">
<!--      <a-button-->
<!--        v-auth="$_ButtonPermission.ORG_ADDPROJECT"-->
<!--        v-track-click="{trackName: '运营项目-新建项目'}"-->
<!--        class="goodsSelectStyle"-->
<!--        type="primary"-->
<!--         @click="createProject"-->
<!--      >-->
<!--        <img src="@/assets/img/icon_xinjxm.png" alt="">-->
<!--        新建项目-->
<!--      </a-button>-->
      <a-table
        :columns="tableListColumns"
        :data-source="List"
        :loading="loading.getList"
        :pagination="pagination"
        class="table-sigle"
        row-key="id"
        @change="tableChange"
      >
        <template :slot="'status'" slot-scope="text">
          <div :class="{status: true, isDisabled: text !== ENABLE}">
            {{STATUS[text]}}
          </div>
        </template>
        <template :slot="'caozuo'" slot-scope="text, record">
          <span v-track-click="{trackName: '运营项目-自动应用'}" v-auth="$_ButtonPermission.ORG_EDIT" class="textBtn" @click="onAuto(record)">自动应用</span>
<!--          <span v-track-click="{trackName: '运营项目-修改'}" v-auth="$_ButtonPermission.ORG_EDIT" class="textBtn" @click="onEdit(record)">修改</span>-->
<!--          <span v-track-click="{trackName: record.status === ENABLE ? '运营项目-禁用' : '运营项目-启用'}" v-auth="$_ButtonPermission.ORG_ENABLE" :class="{textBtn: true, delete: record.status === ENABLE}" @click="onEnable(record)">{{ record.status === ENABLE ? '禁用' : '启用'}}</span>-->
        </template>
      </a-table>
    </div>
    <!-- 新建项目 -->
    <div v-if="visible">
      <a-modal
      v-model="visible"
      width="800px"
      :mask-closable="false"
      :title="addTitle"
      :footer="null"
      centered
      @cancel="onhidden"
    >
      <a-form-model ref="proModel" :model="form" :rules="rules" >
        <a-form-model-item v-if="!isEnterprise&&tenantList.length>1" ref="tenant" :colon="false" v-bind="colWidth" label="服务商" prop="customerId">
          <a-select
            v-model="form.customerId"
            placeholder="请选择服务商"
            style="width: 100%"
            :filter-option="false"
            @change="handleChangeCustomer"
          >
            <a-select-option
              v-for="item in tenantList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.customerName }}({{item.carrierTenantName}})
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item ref="name" :colon="false" v-bind="colWidth" label="项目名称" prop="projectName">
          <a-input v-model="form.projectName" placeholder="长度不超过20位" />
        </a-form-model-item>
        <!-- <a-form-model-item v-if="addTitle !== '修改项目'" ref="code" :colon="false" v-bind="colWidth" label="项目编码" prop="projectCode">
          <a-input v-model="form.projectCode" placeholder="长度不超过18位，不填写系统自动生成" />
        </a-form-model-item> -->
         <a-form-model-item v-if="isEnterprise" ref="tenantId"  :colon="false" v-bind="colWidth" label="所属服务商" prop="tenantId">
          <selectCarrier is-query-all :value="form.customerId" :is-default-select="true" @change="handleChange"  />
        </a-form-model-item>
        <a-form-model-item ref="contractProjectCode" :colon="false" v-bind="colWidth" label="关联合同项目" prop="contractProjectCode">
          <a-select
            v-model="form.contractProjectCode"
            show-search
            allow-clear
            placeholder="请选择关联合同项目"
            style="width: 100%"
            :filter-option="false"
            :options="projectList"
            @search="fetchProject"
            @change="changeProject"
          >
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <a-row class="btnBox">
        <a-col :span="8" :offset="16">
          <a-button @click="onhidden">取消</a-button>
          <a-button v-track-click="{trackName: addTitle === '修改项目' ? '运营项目-修改-提交' : '运营项目-新增-提交'}" type="primary" @click="addOrg">提交</a-button>
        </a-col>
      </a-row>
    </a-modal>
    </div>
    <auto-application ref="autoApplication" />
  </div>
</template>

<script>
import moment from "moment";
import loadingMixin from "@thales/loading";
import TableSearch from '@/components/TableSearch/index.vue'
import selectCarrier from '@/components/selectCarrier/serviceSelect.vue'
import {formatNullData} from '@/utils/util'
import { getContractProject,projectPage,customerList,projectUpsert,projectStatusUpsert } from './api'
import { ProjectSearch } from './constant'
import AutoApplication from './component/AutoApplication.vue'

const STATUS = {
  'ENABLE': '启用',
  'DISABLE': ' 禁用'
}
const ENABLE = 'ENABLE' // 启用

export default {
  name: "ProjectList",
  components: {
    selectCarrier,
    TableSearch,
    AutoApplication
  },
  mixins: [loadingMixin],
  props: {},
  data() {
    return {
      pageSize: 10,
      STATUS,
      ENABLE,
      queryForm: {},
      ProjectSearch,
      loading: {
        getList: false,
      },
      tenantList: [],
      tableListColumns: [
        {
          title: "运营项目名称",
          dataIndex: "projectName",
          key: "projectName",
          width: 220,
          ellipsis: true,
          scopedSlots: { customRender: "projectName" },
        },
        {
          title: "运营项目编码",
          dataIndex: "projectCode",
          key: "projectCode",
          width: 300,
          ellipsis: true,
          scopedSlots: { customRender: "projectCode" },
        },
        {
          title: "关联合同项目编码",
          dataIndex: "contractProjectCode",
          key: "contractProjectCode",
          ellipsis: true,
          width: 220,
          customRender: (text) => text || '--',
        },
        {
          title: "关联合同项目名称",
          dataIndex: "contractProjectName",
          key: "contractProjectName",
          ellipsis: true,
          width: 220,
          customRender: (text) => text || '--',
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "status" },
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
          width: 240,
          ellipsis: true,
          scopedSlots: { customRender: "createTime" },
        },
        {
          title: "创建人",
          dataIndex: "createUserName",
          key: "createUserName",
          width: 140,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "caozuo",
          key: "caozuo",
          width: 90,
          fixed:'right',
          scopedSlots: { customRender: "caozuo" },
        },
      ],
      List: [],
      // projectName: "",
      pagination: {
        current: 1,
        total: 0,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        onShowSizeChange: (current, pageSize) => {
          this.pageSize = pageSize;
        },
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      visible: false,
      form: {
        name: "",
        code: "",
        contractProjectCode: undefined,
      },
      rules: {
        customerId: [
          { required: true, message: "请选择服务商", trigger: "change" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "change" },
          { max: 20, message: "长度不超过20字符", trigger: "change" },
        ],
        projectCode: [
          { required: false, max: 18, message: "长度不超过18字符", trigger: "change" }
        ],
        contractProjectCode: [
          // { required: true, message: "请选择关联合同项目", trigger: "change" }
        ],
      },
      colWidth:{
        labelCol: {span: 5},
        wrapperCol: {span: 19}
      },
      addTitle: '',
      accountData: {},
      id: '',
      projectList: [],
      editData: {},
    };
  },
  computed: {},
  created() {
    const {creditCode}=this.$store.state.user
    this.isEnterprise=!!creditCode
    if(!creditCode){
      this.accountData = JSON.parse(localStorage.getItem('accountData'));
       this.getTenantList()
    }
    this.getList()
  },
  mounted() {},
  methods: {
    handleChangeCustomer(value){
      if(value){
      const select = this.tenantList.find(item=>item.id===value);
      const {customerCode,customerName,carrierTenantId,carrierTenantName} = select;
      this.$set(this,'form',{...this.form,customerCode,customerName,tenantId:carrierTenantId,tenantName:carrierTenantName})
     }else{
      this.$set(this,'form',{...this.form,customerId:'',customerCode:'',customerName:'',tenantId:'',tenantName:''})
     }
    },
    async getTenantList() {
      const {customerCode}=this.$store.state.user
      const res = await customerList({
        isQueryAll:true,
        customerCode,
        cooperativeNatureCodes: [2, 4],
        ignoreTenant: true,
        statuses: [0],
      })
      this.tenantList = res.records||[];
    },
    handleChange(value){
     if(value){
      const {id,customerCode,customerName,carrierTenantId,carrierTenantName} = value;
      this.$set(this,'form',{...this.form,customerId:id,customerCode,customerName,tenantId:carrierTenantId,tenantName:carrierTenantName})
     }else{
      this.$set(this,'form',{...this.form,customerId:'',customerCode:'',customerName:'',tenantId:'',tenantName:''})
     }
    },
    filterData(data, value) {
      return data === value ? null : data;
    },
    searchList() {
      this.pagination.current = 1;
      this.getList();
    },
    changeProject(val) {
      if (!val) {
        this.fetchProject()
      }
    },
    async fetchProject(name, isEdit) {
      // 获取合同项目列表
      const paramsName = isEdit ? 'code' : 'name'
      const res = await getContractProject({
        [paramsName]: name,
      })
      const list = []
      res.records.forEach(item => {
        list.push({
          value: item.code,
          label: item.name
        })
      })
      this.projectList = list
    },
    async getList() {
      const data = {
        ...formatNullData(this.queryForm),
        source:'OWN',
        statusList: ["ENABLE", "DISABLE"],
      };
      const {creditCode,customers,customerCode}=this.$store.state.user
      if(creditCode){
        data.customerCodes=customers.map(item=>item.customerCode)
      }else{
        data.customerCodes=[customerCode]
        }
      const params = {
        size: this.pageSize,
        page: this.pagination.current,
        sort: 'createTime__DESC'
      };
      const res = await projectPage(data, params)
      this.List = res.records.map((e) => {
        return {
          ...e,
          createTime: moment(e.createTime).format('YYYY-MM-DD HH:mm:ss')
        }
      })
      this.pagination.total = res.total
    },
    handleReset() {
      this.queryForm = {}
      this.pagination.current = 1;
      this.getList()
    },
    reset() {
      this.getList()
    },
    tableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
      };
      this.getList();
    },
    onhidden() {
      this.visible = false;
    },
    createProject() {
      this.visible = true;
      this.addTitle = '新建项目';
      this.$set(this,'form',{})
      this.editData = {}
      this.form.contractProjectCode = undefined
      if (this.tenantList.length === 1) {
        this.form.customerId = this.tenantList[0].id
        this.handleChangeCustomer(this.form.customerId)
      }
      this.fetchProject()
    },
    onAuto(data) {
      this.$refs.autoApplication.show(data)
    },
    onEdit(data) {
      this.editData = data;
      this.visible = true;
      this.addTitle = '修改项目';
      this.form.projectName = data.projectName;
      this.form.name = data.name;
      this.id = data.id;
      this.form.customerId =data.customerId;
      if(!this.isEnterprise){
        this.handleChangeCustomer(this.form.customerId)
      }
      this.form.contractProjectCode = data.contractProjectCode || undefined
      this.fetchProject(data.contractProjectCode || '', true)
    },
    validateProjectManager(data) {
      // 判断是否填写完整
      let flag = true;
      data.forEach(t => {
        if(t.id===''){
          flag = false;
        }
      })
      return flag
    },
    validateIsRepeat(data) {
      const list = [...new Set(data.map(t => t.id))]
      if(list.length!==data.length){
        return false
      }
      return true
    },
    addOrg() {
      this.$refs.proModel.validate((boolean)=>{
        if (boolean) {
          const data = { ...this.editData,...this.form}
          if (this.form.contractProjectCode) {
            const name = this.projectList.filter(item => item.value === this.form.contractProjectCode)[0]?.label || ''
            data.contractProjectName = name
          } else {
            data.contractProjectCode = ''
            data.contractProjectName = ''
          }
          if(this.addTitle === '修改项目'){
            data.bizTypes = null
            // data.bizTypes = (this.editData.bizTypes || []).map(item => {
            //   return {
            //     bizType: item.bizType,
            //     groupId: item.projectGroup?.id,
            //     groupName: item.projectGroup?.groupName
            //   }
            // })
            data.id = this.id
            projectUpsert(data).then(() => {
              this.$message.success('修改成功')
              this.visible = false;
              this.getList()
            })
          } else{
            projectUpsert(data).then(() => {
              this.$message.success('新建成功')
              this.visible = false;
              this.getList()
            })
          }
        }
      })
    },
    onEnable(res) {
      const data = {
        id: res.id,
        status: res.status === ENABLE ? 'DISABLE' : 'ENABLE',
      }
      projectStatusUpsert(data).then(() => {
        this.$message.success('修改成功')
        this.getList()
      })
    }
  },
};
</script>

<style lang="less" scoped>
.table-search {
  background: #fff;
  padding: 24px;
  border-radius: 0px 6px 6px 6px;
}
.tablebox {
  margin-bottom: 10px;
  margin-top: 20px;
  background: #fff;
  padding: 24px;
  border-radius: 6px;
  position: relative;
  .status {
    display: flex;
    align-items: center;
  }
  .status::before {
    content: '';
    width: 6px;
    height: 6px;
    background: #06B880;
    border-radius: 50%;
    display: inline-block;
    margin-right: 4px;
  }
  .isDisabled::before {
    background: #ED4934;
  }
  /deep/ .ant-table-body {
    overflow-y: auto;
  }
}
.goodsSelectStyle {
  margin: 4px 0 20px 0;
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}
.textBtn {
  color: #06b880;
  margin-right: 15px;
  &:hover {
    cursor: pointer;
  }
  &.delete {
    color: #969799;
  }
}
.tr {
  text-align: right;
}
.btnBox {
  text-align: right;
  button {
    margin-left: 15px;
  }
}
.color-red{
  color:red;
}
</style>

<style lang="less">
.bgc_tooltip{
  min-width: 650px;
}
.manager-list{
  display:flex;
  white-space: nowrap;
  .email{
    margin:0 20px 0 10px
  }
  .compa{
    margin-right:10px;
  }
  .phone{
    text-align:right;
  }
}
</style>
